export default __webpack_public_path__ + "static/media/alternative.7ec5a3a5.png";